import React from 'react';
import { Link } from 'react-router-dom';

interface QuickStartCardProps {
  to: string;
  borderColor: string;
  iconColor: string;
  icon: React.ReactNode;
  title: string;
  description: string;
}

export const QuickStartCard: React.FC<QuickStartCardProps> = ({
  to,
  borderColor,
  iconColor,
  icon,
  title,
  description
}) => (
  <Link 
    to={to}
    className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all transform hover:-translate-y-1"
    style={{ borderTop: `4px solid ${borderColor}` }}
  >
    <div className="mb-3">
      <span style={{ 
        display: 'inline-flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        width: '48px',
        height: '48px',
        backgroundColor: iconColor,
        borderRadius: '12px'
      }}>
        {icon}
      </span>
    </div>
    <h3 className="font-semibold text-lg mb-2" style={{ color: '#4A6651' }}>{title}</h3>
    <p className="text-sm" style={{ color: '#598D76' }}>{description}</p>
  </Link>
);